// node_modules
import { createContext, useEffect, useState } from "react";
// Controllers
import { UserControllerSingleton } from "Controllers";
// Types
import { TUserDTO } from "Types";
import { UserLogicSingleton } from "Logics";

type TUserContext = {
    currentUser: TUserDTO,
    isCurrentUserFindest: boolean
}

type TUserProviderProps = {
    children: null | JSX.Element | JSX.Element[]
}

export const UserContext = createContext<TUserContext>({} as TUserContext);

export const UserProvider = ({children}: TUserProviderProps) => {
    // State
    const [isFindestUser, setIsFindestUser] = useState<boolean>(false);
    const [currentUser, setCurrentUser] = useState<TUserDTO | undefined>();

    // Logic
    const setCurrentUserAsync = async (): Promise<void> => {
        const user = await UserControllerSingleton.getCurrentAsync();
        setCurrentUser(user);
        setIsFindestUser(UserLogicSingleton.isFindestUser(user));
    };

    useEffect(() => {
        setCurrentUserAsync();
    }, []);

    // Render
    return (
        <UserContext.Provider value={{currentUser: currentUser ? currentUser : {id: "", email: "", roles: [], policies: []}, isCurrentUserFindest: isFindestUser}}>
            {children}
        </UserContext.Provider>
    );
};